import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class AutoWahEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect tall-effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';

        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Filter Cutoff'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.baseFrequencyParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={10}
                        max={10000}
                        min={0}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Octave'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.octaveParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={10}
                        min={0}
                        />
                     <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Q'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.qParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={1}
                        max={10}
                        min={0}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Sensitivity'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.sensitivityParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={1}
                        max={3}
                        min={-30}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Attack'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.attackParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={4}
                        min={0.1}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Release'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.releaseParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={4}
                        min={0.1}
                        />
                      <WetSlider
                        effectNumber={this.props.effectNumber}
                    sequencerEngine={this.props.sequencerEngine}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        effect={this.state.effect}/>
                </div>} 
            </div>
        );
    }
}

export default AutoWahEffect;
